import SidebarLayout from "@/components/feature/SidebarLayout";
import { useScrollReveal, getRevealClass } from "@/hooks/useScrollReveal";

export default function Farm() {
  const { ref, isVisible } = useScrollReveal();

  return (
    <SidebarLayout breadcrumbs={[{ label: 'ファーム事業' }]}>

      {/* Hero */}
      <section className="px-4 md:px-6 lg:px-10 mb-10">
        <div className="relative w-full h-[320px] sm:h-[400px] md:h-[500px] lg:h-[580px] overflow-hidden rounded-2xl">
          <img
            src="https://static.readdy.ai/image/8da10c853ee44f0b201c0b84a1169777/42040e0a075fb071b9efc23075eb2bad.webp"
            alt="ファーム事業"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-black/25" />
          <div ref={ref} className={`absolute inset-0 flex flex-col items-center justify-center z-10 ${getRevealClass(isVisible)}`}>
            <h1
              className="text-3xl sm:text-4xl md:text-5xl font-bold text-white tracking-wide"
              style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
            >
              Farm
            </h1>
            <p
              className="text-xs sm:text-sm text-white/80 mt-2 tracking-wider"
              style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
            >
              ファーム事業
            </p>
          </div>
        </div>
      </section>

      {/* Content */}
      <div className="px-4 md:px-6 lg:px-10 pb-16 md:pb-24">
        <div className="bg-white rounded-2xl p-8 md:p-12 lg:p-16">
          <div className="max-w-5xl mx-auto">
            {/* Text + Image */}
            <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-start mb-14">
              {/* Text */}
              <div className="flex-1">
                <div
                  className="text-base md:text-lg text-gray-800 leading-[2.2] tracking-wide"
                  style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                >
                  <p className="mb-5">
                    大分の特産品かぼすの発祥地・臼杵市乙見に2.3haのかぼす園、
                    <br className="hidden md:block" />
                    さらに佐伯市蒲江に60aのセミノール園を経営。
                  </p>
                  <p className="mb-5">
                    オリジナルブランドかぼすの「乙御KABOS」をはじめ、自社生産の県産シトラスを是非ご賞味ください。
                  </p>
                  <p className="mb-5">
                    弊社が生産した商品をお取り扱いしていただける事業者様を随時募集しております。
                    <br />
                    お気軽にcontactからお問い合わせください。
                  </p>
                  <p>
                    一般の消費者様向けに販売も行っております。下記よりご覧ください。
                  </p>
                </div>
              </div>

              {/* Image */}
              <div className="w-full lg:w-[380px] shrink-0">
                <div className="w-full aspect-[3/4] overflow-hidden rounded-xl">
                  <img
                    src="https://static.readdy.ai/image/8da10c853ee44f0b201c0b84a1169777/23bf4adb196377faccc58c97bed306f7.webp"
                    alt="乙御KABOS"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>

            {/* Purchase Button */}
            <div className="text-center pt-6">
              <a
                href="https://olcompany.base.shop/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center w-full max-w-sm px-8 py-4 bg-[#3D3D3D] text-white text-sm font-medium rounded-lg hover:bg-[#2a2a2a] transition-colors whitespace-nowrap"
              >
                ご購入はこちら
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Story */}
      <div className="px-4 md:px-6 lg:px-10 pb-16 md:pb-24">
        <div className="max-w-5xl mx-auto">

          {/* Main Visual */}
          <div className="relative w-full h-[420px] sm:h-[480px] md:h-[560px] overflow-hidden rounded-2xl mb-14 md:mb-20">
            <img
              src="https://storage.helloreaddy.io/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/dd77afb4-74ad-40e4-813f-3a536a399645_compressed_kabos.webp"
              alt="かぼす園の風景"
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/40" />
            <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6 z-10">
              <h2
                className="text-2xl sm:text-3xl md:text-4xl lg:text-[42px] font-bold text-white tracking-wide leading-snug max-w-3xl"
                style={{ fontFamily: "'Noto Serif JP', serif" }}
              >
                300年の時を超えて咲き誇る、<br className="hidden md:block" />至高のかぼす物語。
              </h2>
              <p
                className="text-sm md:text-base text-white/85 mt-4 tracking-wider max-w-xl"
                style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
              >
                大分県臼杵市乙見——発祥の地から届ける、香りと酸味の真骨頂。
              </p>
            </div>
          </div>

          {/* 1695年の伝承 */}
          <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center mb-16 md:mb-24">
            <div className="w-full lg:w-[380px] shrink-0 order-1 lg:order-1">
              <div className="w-full aspect-[3/4] overflow-hidden rounded-xl">
                <img
                  src="https://storage.helloreaddy.io/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/777ab2d7-d041-4a5c-8d64-9f7b617cc87f_compressed_kabo001.webp"
                  alt="臼杵市乙見の古木"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
            <div className="flex-1 order-2 lg:order-2">
              <p
                className="text-xs md:text-sm font-semibold tracking-[0.2em] text-[#5B7A3A] mb-3"
                style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
              >
                1695年の伝承と臼杵市乙見の歴史
              </p>
              <h3
                className="text-xl md:text-2xl font-bold text-gray-900 tracking-wide mb-5 leading-snug"
                style={{ fontFamily: "'Noto Serif JP', serif" }}
              >
                かぼす発祥の地・臼杵市乙見
              </h3>
              <div
                className="text-sm md:text-base text-gray-700 leading-[2.1] tracking-wide"
                style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
              >
                <p className="mb-4">
                  大分県臼杵市乙見（おとみ）。この静かな山あいの集落こそが、日本の「かぼす」発祥の地とされています。
                </p>
                <p className="mb-4">
                  その歴史は今から300年以上前、江戸時代の元禄8年（1695年）にまで遡ります。一説には、京都から持ち帰った香気あふれる柑橘の種がこの地に植えられ、大地の恵みを受けて独自の進化を遂げたのが始まりと言われています。
                </p>
                <p>
                  以来、代々この地で大切に守り受け継がれてきた伝統の味覚。乙見の豊かな自然と気候が育むかぼすは、他にはない深いコクと爽快な香りを誇ります。
                </p>
              </div>
            </div>
          </div>

          {/* 耕作放棄地の再生 */}
          <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center mb-16 md:mb-24">
            <div className="flex-1 order-2 lg:order-1">
              <p
                className="text-xs md:text-sm font-semibold tracking-[0.2em] text-[#5B7A3A] mb-3"
                style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
              >
                耕作放棄地の再生
              </p>
              <h3
                className="text-xl md:text-2xl font-bold text-gray-900 tracking-wide mb-5 leading-snug"
                style={{ fontFamily: "'Noto Serif JP', serif" }}
              >
                2022年、荒れた大地を再び息づかせる
              </h3>
              <div
                className="text-sm md:text-base text-gray-700 leading-[2.1] tracking-wide"
                style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
              >
                <p className="mb-4">
                  しかし、時代の変化とともに後継者不足や高齢化が進み、かつて青々と実っていた美しいかぼす農園も、一時期は雑草や荒木に覆われた「耕作放棄地」へと変わりつつありました。
                </p>
                <p className="mb-4">
                  <span className="font-semibold text-gray-900">
                    「この歴史あるかぼすの文化を、私たちの世代で絶やすわけにはいかない」
                  </span>
                </p>
                <p className="mb-4">
                  そんな強い危機感と情熱を胸に、私たちは2022年、荒れ果てた2.3ヘクタールの土地を開墾し直すプロジェクトを始動しました。大木を伐採し、土を耕し、太陽の光が注ぐ環境を取り戻す作業は泥臭く過酷な道のりでしたが、地域の方々の想いと共に、奇跡的に息を吹き返しました。
                </p>
              </div>
            </div>
            <div className="w-full lg:w-[380px] shrink-0 order-1 lg:order-2">
              <div className="w-full aspect-[3/4] overflow-hidden rounded-xl">
                <img
                  src="https://readdy.ai/api/search-image?query=Freshly%20cultivated%20farmland%20being%20restored%20in%20rural%20Oita%20Japan%2C%20young%20kabosu%20citrus%20saplings%20planted%20in%20neat%20rows%20of%20dark%20tilled%20soil%2C%20cleared%20forest%20edge%20in%20background%2C%20bright%20sunlight%20breaking%20through%2C%20hopeful%20renewal%20atmosphere%2C%20green%20sprouts%2C%20editorial%20documentary%20photography&width=800&height=1066&seq=farm-story-reclaim&orientation=portrait"
                  alt="開墾された農園"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>

          {/* 乙御KABOSの完成 */}
          <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center mb-16 md:mb-24">
            <div className="w-full lg:w-[380px] shrink-0 order-1 lg:order-1">
              <div className="w-full aspect-[3/4] overflow-hidden rounded-xl">
                <img
                  src="https://storage.helloreaddy.io/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/bf7995d5-f425-4597-9dd5-e1a47005d69b_compressed_S__88252421.webp"
                  alt="乙御KABOS"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
            <div className="flex-1 order-2 lg:order-2">
              <p
                className="text-xs md:text-sm font-semibold tracking-[0.2em] text-[#5B7A3A] mb-3"
                style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
              >
                「乙御KABOS」の完成
              </p>
              <h3
                className="text-xl md:text-2xl font-bold text-gray-900 tracking-wide mb-5 leading-snug"
                style={{ fontFamily: "'Noto Serif JP', serif" }}
              >
                発祥の地のプライドと、現代の情熱が結実
              </h3>
              <div
                className="text-sm md:text-base text-gray-700 leading-[2.1] tracking-wide"
                style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
              >
                <p className="mb-4">
                  土壌づくりから徹底的に見直し、樹々一本一本と丁寧に向き合うことで生まれた至高の一品、それが「乙御KABOS（おとみカボス）」です。
                </p>
                <p className="mb-4">
                  丸ごと搾った瞬間に広がるフレッシュで芳醇な香り、ツンと角のない上品で柔らかな酸味、そして余韻に残る旨み。発祥の地・乙見のプライドと、現代の情熱が結実したプレミアムなブランドかぼすがここに誕生しました。
                </p>
              </div>
            </div>
          </div>

          {/* 私たちの想い */}
          <div className="relative w-full overflow-hidden rounded-2xl p-8 md:p-14 lg:p-16">
            <img
              src="https://storage.helloreaddy.io/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/80fbe974-b27b-4c15-b785-797384ffe383_compressed_OL4.webp"
              alt="かぼすを手に持つ"
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-black/55" />
            <div className="relative z-10 text-center max-w-3xl mx-auto">
              <p
                className="text-xs md:text-sm font-semibold tracking-[0.2em] text-lime-300 mb-4"
                style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
              >
                私たちの想い
              </p>
              <h3
                className="text-xl md:text-2xl lg:text-3xl font-bold text-white tracking-wide mb-6 leading-snug"
                style={{ fontFamily: "'Noto Serif JP', serif" }}
              >
                届けているのは、単なる果実ではありません。
              </h3>
              <div
                className="text-sm md:text-base text-white/90 leading-[2.2] tracking-wide"
                style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
              >
                <p className="mb-5">
                  300年以上続いてきた臼杵市乙見の歴史、そして地域の人々が紡いできた温かいストーリーそのものです。
                </p>
                <p className="mb-5 text-base md:text-lg font-semibold text-white">
                  「本物の味と輝きを、地域から全国へ、そして世界へ。」
                </p>
                <p>
                  乙御KABOSを通じて、食卓に一滴の感動と笑顔をお届けすることをお約束します。
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>

      {/* Contact CTA */}
      <div className="px-4 md:px-6 lg:px-10 pb-16 md:pb-24">
        <div className="bg-[#025ab0] rounded-2xl p-8 md:p-12 lg:p-16">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-8 max-w-5xl mx-auto">
            <div>
              <h2
                className="text-2xl md:text-3xl font-bold text-white tracking-wide mb-2"
                style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
              >
                お問い合わせ
              </h2>
              <p
                className="text-white/80 text-sm md:text-base"
                style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
              >
                お客様からのお問い合わせをお待ちしております。お気軽にご連絡ください。
              </p>
            </div>
            <a
              href="/contact"
              className="inline-flex items-center gap-2 px-8 py-3 bg-white text-[#025ab0] text-sm font-medium rounded-full hover:bg-gray-100 transition-colors whitespace-nowrap"
            >
              お問い合わせ
            </a>
          </div>
        </div>
      </div>
    </SidebarLayout>
  );
}